export default __webpack_public_path__ + "static/media/about_image_small.7fae5ba7.jpg";